module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 mb-4 has-feedback",
    class: {
      'has-success': _vm.fnameValid, 'has-error': !_vm.fnamePotentiallyValid
    }
  }, [_vm._v("\n      First name"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.fname),
      expression: "form_data.fname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "fname", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.fnameValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid first name")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 has-feedback",
    class: {
      'has-success': _vm.mnamiValid, 'has-error': !_vm.mnamiPotentiallyValid
    }
  }, [_vm._v("\n        Middle Initial"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.mnami),
      expression: "form_data.mnami"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('A'),
      expression: "'A'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.mnami)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "mnami", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.mnamiValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid initial")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 has-feedback",
    class: {
      'has-success': _vm.lnameValid, 'has-error': !_vm.lnamePotentiallyValid
    }
  }, [_vm._v("\n        Last name"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.lname),
      expression: "form_data.lname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "lname", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.lnameValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid last name")]) : _vm._e()])]), _vm._v(" "), (_vm.is_company) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 has-feedback",
    class: {
      'has-success': _vm.companyNameValid, 'has-error': !_vm.companyNamePotentiallyValid
    }
  }, [_vm._v("\n      Company name"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.cmp_name),
      expression: "form_data.cmp_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.cmp_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "cmp_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.companyNameValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid company name")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('address-form', {
    on: {
      "input": _vm.setAddress,
      "form-state": _vm.setAddressValid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc9c0e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RevioAddress.vue
// module id = 1346
// module chunks = 16